import {
  mdsBorderRadiusValue,
  mdsTransitionsValue,
  mdsColorsValue,
  mdsFontSizesValue,
  mdsLineHeightsValue,
  mdsFontWeightsValue,
  mdsLineSpacingsValue,
  mdsSpacingsValue,
  mdsSidebarWidthsValue,
  mdsBordersValue,
  mdsShadowsValue,
  mdsBreakpointsValue,
  mdsMediaQueriesValue,
} from "@/design-system/foundations";
import { Theme } from "@emotion/react";

export const mdsCommonTheme: Theme = {
  colors: mdsColorsValue,
  fontSizes: mdsFontSizesValue,
  fontWeights: mdsFontWeightsValue,
  borderRadius: mdsBorderRadiusValue,
  lineHeights: mdsLineHeightsValue,
  lineSpacings: mdsLineSpacingsValue,
  transitions: mdsTransitionsValue,
  spacing: mdsSpacingsValue,
  sidebar: mdsSidebarWidthsValue,
  borders: mdsBordersValue,
  shadows: mdsShadowsValue,
  breakpoints: mdsBreakpointsValue,
  mediaQueries: mdsMediaQueriesValue,
};
